var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{on:{"click":_vm.onExport}},[_c('v-list-item-title',[_vm._v("Export CSV")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }